import settings from '@/settings'

let pegarRedes = (headers) => {
  return fetch(`${settings.apetrusApi}/redes/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let cadastrar = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let atualizar = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/atualizar/${data.id_rede}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let postosSemRede = (headers) => {
  return fetch(`${settings.apetrusApi}/redes/semrede/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let postosDaRede = (headers, id) => {
  return fetch(`${settings.apetrusApi}/redes/postosdarede/${id}/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inserirEmRede = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/inseriremrede/${data.id_rede}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let postoMatriz = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/postomatriz/${data.id}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let detalhesRede = (headers, id) => {
  return fetch(`${settings.apetrusApi}/redes/${id}/detalhes/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let removerDaRede = (headers, data) => {
  return fetch(`${settings.apetrusApi}/redes/removerdarede/${data.id}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let deletarRede = (headers, id) => {
  return fetch(`${settings.apetrusApi}/redes/deletar/${id}/`, {
    method: 'DELETE',
    mode: 'cors',
    headers: headers
  })
}

export default {
  pegarRedes,
  cadastrar,
  atualizar,
  postosSemRede,
  postosDaRede,
  inserirEmRede,
  postoMatriz,
  detalhesRede,
  removerDaRede,
  deletarRede
}
